// RouteLink.js
import React, { Suspense } from "react";
import { Navigate } from "react-router-dom";

// Lazy load components for code splitting
const LoginPage = React.lazy(() => import("./Pages/Login/LoginPage"));
const DashboardLayout = React.lazy(() => import("./Layout/DashboardLayout"));
const DashboardHome = React.lazy(
  () => import("./Pages/Dashboard/DashboardHome"),
);
const PrivateRoute = React.lazy(() => import("./Utilities/PrivateRoute"));
const Village = React.lazy(() => import("./Pages/Village/Village"));
const AddVillage = React.lazy(() => import("./Pages/Village/AddVillage"));
const Booth = React.lazy(() => import("./Pages/Booth/Booth"));
const AddBooth = React.lazy(() => import("./Pages/Booth/AddBooth"));
const Citizen = React.lazy(() => import("./Pages/Citizen/Citizen"));
const AddCitizen = React.lazy(() => import("./Pages/Citizen/AddCitizen"));
const Event = React.lazy(() => import("./Pages/Event/Event"));
const AddEvent = React.lazy(() => import("./Pages/Event/AddEvent"));
const Ticket = React.lazy(() => import("./Pages/Ticket/Ticket"));
const AddTicket = React.lazy(() => import("./Pages/Ticket/AddTicket"));
const TicketChat = React.lazy(() => import("./Pages/Ticket/TicketChat"));
const Grampanchayat = React.lazy(
  () => import("./Pages/Grampanchayat/Grampanchayat"),
);
const AddGrampanchayat = React.lazy(
  () => import("./Pages/Grampanchayat/AddGrampanchayat"),
);
const BoothCoordinator = React.lazy(
  () => import("./Pages/BoothCoordinator/BoothCoordinator"),
);
const AddBoothCoordinator = React.lazy(
  () => import("./Pages/BoothCoordinator/AddBoothCoordinator"),
);
const BoothAssign = React.lazy(() => import("./Pages/BoothAssign/BoothAssign"));
const AddBoothAssign = React.lazy(
  () => import("./Pages/BoothAssign/AddBoothAssign"),
);
const Cluster = React.lazy(() => import("./Pages/Cluster/Cluster"));
const AddCluster = React.lazy(() => import("./Pages/Cluster/AddCluster"));
const Zone = React.lazy(() => import("./Pages/Zone/Zone"));
const AddZone = React.lazy(() => import("./Pages/Zone/AddZone"));
const BoothVillageMapping = React.lazy(
  () => import("./Pages/BoothVillageMapping/BoothVillageMapping"),
);
const AddBoothVillageMapping = React.lazy(
  () => import("./Pages/BoothVillageMapping/AddBoothVillageMapping"),
);
const BusVolunteer = React.lazy(
  () => import("./Pages/BusVolunteer/BusVolunteer"),
);
const AddBusVolunteer = React.lazy(
  () => import("./Pages/BusVolunteer/AddBusVolunteer"),
);
const WomenVolunteer = React.lazy(
  () => import("./Pages/WomenVolunteer/WomenVolunteer"),
);
const AddWomenVolunteer = React.lazy(
  () => import("./Pages/WomenVolunteer/AddWomenVolunteer"),
);
const MemberMaster = React.lazy(
  () => import("./Pages/MemberMaster/MemberMaster"),
);
const AddMemberMaster = React.lazy(
  () => import("./Pages/MemberMaster/AddMemberMaster"),
);
const MasterReports = React.lazy(
  () => import("./Pages/MasterReports/MasterReports"),
);
const AuditLog = React.lazy(() => import("./Pages/AuditLog/AuditLog"));

const routes = [
  {
    path: "/login",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <LoginPage />
      </Suspense>
    ),
  },
  {
    path: "/",
    element: <Navigate to="/login" replace />,
  },
  {
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <PrivateRoute />
      </Suspense>
    ), // 🛡 Wrap protected routes here
    children: [
      {
        path: "/dashboard",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <DashboardLayout />
          </Suspense>
        ),
        children: [
          {
            index: true,
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <DashboardHome />
              </Suspense>
            ),
          },
          //
          {
            path: "zone",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <Zone />
              </Suspense>
            ),
          },
          {
            path: "zoneadd",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <AddZone />
              </Suspense>
            ),
          },
          //
          {
            path: "cluster",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <Cluster />
              </Suspense>
            ),
          },
          {
            path: "clusteradd",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <AddCluster />
              </Suspense>
            ),
          },

          {
            path: "grampanchayat",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <Grampanchayat />
              </Suspense>
            ),
          },
          {
            path: "grampanchayatadd",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <AddGrampanchayat />
              </Suspense>
            ),
          },
          //
          {
            path: "village",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <Village />
              </Suspense>
            ),
          },
          {
            path: "villageadd",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <AddVillage />
              </Suspense>
            ),
          },
          //
          {
            path: "booth",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <Booth />
              </Suspense>
            ),
          },
          {
            path: "boothadd",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <AddBooth />
              </Suspense>
            ),
          },
          // Booth Coordinator
          {
            path: "boothcoordinator",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <BoothCoordinator />
              </Suspense>
            ),
          },
          {
            path: "boothcoordinatoradd",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <AddBoothCoordinator />
              </Suspense>
            ),
          },
          //
          {
            path: "boothcoordinatorassign",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <BoothAssign />
              </Suspense>
            ),
          },
          {
            path: "boothcoordinatorassignadd",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <AddBoothAssign />
              </Suspense>
            ),
          },

          {
            path: "boothvillagemapping",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <BoothVillageMapping />
              </Suspense>
            ),
          },
          {
            path: "boothvillagemappingadd",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <AddBoothVillageMapping />
              </Suspense>
            ),
          },
          //
          //
          {
            path: "citizen",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <Citizen />
              </Suspense>
            ),
          },
          {
            path: "citizenadd",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <AddCitizen />
              </Suspense>
            ),
          },
          //
          {
            path: "womenvolunteer",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <WomenVolunteer />
              </Suspense>
            ),
          },
          {
            path: "womenvolunteeradd",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <AddWomenVolunteer />
              </Suspense>
            ),
          },
          {
            path: "busvolunteer",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <BusVolunteer />
              </Suspense>
            ),
          },
          {
            path: "busvolunteeradd",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <AddBusVolunteer />
              </Suspense>
            ),
          },
          {
            path: "membermaster",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <MemberMaster />
              </Suspense>
            ),
          },
          {
            path: "membermasteradd",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <AddMemberMaster />
              </Suspense>
            ),
          },
          {
            path: "event",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <Event />
              </Suspense>
            ),
          },
          {
            path: "eventadd",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <AddEvent />
              </Suspense>
            ),
          },
          {
            path: "ticket",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <Ticket />
              </Suspense>
            ),
          },
          {
            path: "ticketadd",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <AddTicket />
              </Suspense>
            ),
          },
          {
            path: "ticketchat",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <TicketChat />
              </Suspense>
            ),
          },
          {
            path: "masterreports",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <MasterReports />
              </Suspense>
            ),
          },
          {
            path: "auditlog",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <AuditLog />
              </Suspense>
            ),
          },
        ],
      },
    ],
  },
];

export default routes;

// // RouteLink.jsOld Routing File
// import React from "react";
// import { Navigate } from "react-router-dom";
// import LoginPage from "./Pages/Login/LoginPage";
// import DashboardLayout from "./Layout/DashboardLayout";
// import DashboardHome from "./Pages/Dashboard/DashboardHome";
// import PrivateRoute from "./Utilities/PrivateRoute";
// import Village from "./Pages/Village/Village";
// import AddVillage from "./Pages/Village/AddVillage";
// import Booth from "./Pages/Booth/Booth";
// import AddBooth from "./Pages/Booth/AddBooth";
// import Citizen from "./Pages/Citizen/Citizen";
// import AddCitizen from "./Pages/Citizen/AddCitizen";
// import Grampanchayat from "./Pages/Grampanchayat/Grampanchayat";
// import AddGrampanchayat from "./Pages/Grampanchayat/AddGrampanchayat";
// import BoothCoordinator from "./Pages/BoothCoordinator/BoothCoordinator";
// import AddBoothCoordinator from "./Pages/BoothCoordinator/AddBoothCoordinator";
// import BoothAssign from "./Pages/BoothAssign/BoothAssign";
// import AddBoothAssign from "./Pages/BoothAssign/AddBoothAssign";
// import Cluster from "./Pages/Cluster/Cluster";
// import AddCluster from "./Pages/Cluster/AddCluster";
// import Zone from "./Pages/Zone/Zone";
// import AddZone from "./Pages/Zone/AddZone";
// import BoothVillageMapping from "./Pages/BoothVillageMapping/BoothVillageMapping";
// import AddBoothVillageMapping from "./Pages/BoothVillageMapping/AddBoothVillageMapping";

// // const routes = [
// //   {
// //     path: '/login',
// //     element: <LoginPage />,
// //   },
// //   {
// //     path: '/',
// //     element: <Navigate to="/login" replace />,
// //   },
// //   {
// //     path: '/dashboard',
// //     element: <DashboardLayout />,
// //     children: [
// //       { index: true, element: <DashboardHome /> },
// //       { path: 'add-user', element: <AddUser /> },
// //       { path: 'delete-user', element: <DeleteUser /> },
// //       { path: 'state', element: <StatePage /> },
// //       { path: 'city', element: <CityPage /> },
// //       { path: 'add-property', element: <AddProperty /> },
// //       { path: 'delete-property', element: <DeleteProperty /> },
// //     ],
// //   },
// // ];

// const routes = [
//   {
//     path: "/login",
//     element: <LoginPage />,
//   },
//   {
//     path: "/",
//     element: <Navigate to="/login" replace />,
//   },
//   {
//     element: <PrivateRoute />, // 🛡 Wrap protected routes here
//     children: [
//       {
//         path: "/dashboard",
//         element: <DashboardLayout />,
//         children: [
//           { index: true, element: <DashboardHome /> },
//           //
//           { path: "zone", element: <Zone /> },
//           { path: "zoneadd", element: <AddZone /> },
//           //
//           { path: "cluster", element: <Cluster /> },
//           { path: "clusteradd", element: <AddCluster /> },

//           { path: "grampanchayat", element: <Grampanchayat /> },
//           { path: "grampanchayatadd", element: <AddGrampanchayat /> },
//           //
//           { path: "village", element: <Village /> },
//           { path: "villageadd", element: <AddVillage /> },
//           //
//           { path: "booth", element: <Booth /> },
//           { path: "boothadd", element: <AddBooth /> },
//           // Booth Coordinator
//           { path: "boothcoordinator", element: <BoothCoordinator /> },
//           { path: "boothcoordinatoradd", element: <AddBoothCoordinator /> },
//           //
//           { path: "boothcoordinatorassign", element: <BoothAssign /> },
//           { path: "boothcoordinatorassignadd", element: <AddBoothAssign /> },

//           { path: "boothvillagemapping", element: <BoothVillageMapping /> },
//           {
//             path: "boothvillagemappingadd",
//             element: <AddBoothVillageMapping />,
//           },
//           //
//           //
//           { path: "citizen", element: <Citizen /> },
//           { path: "citizenadd", element: <AddCitizen /> },
//         ],
//       },
//     ],
//   },
// ];

// export default routes;
